import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 55F32835-0982-43F9-9F2D-42585183016A
 * name comma
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comma.svg
 * tags
 */
export const CommaIcon = createSvgIcon(<><path d="M7,3H16.95V12.96L12.96,20.94H8L11.97,12.96H7V3Z" /></>, 'CommaIcon');
export default CommaIcon